import { WSForm, WSInputNumber } from "@wingspanhq/fe-component-library";
import { AttributeDefinition } from "@wingspanhq/wingspan-api-sdk";

type Props = {
  definition: AttributeDefinition;
  disabled?: boolean;
};

export const FieldNumber: React.FC<Props> = props => {
  return (
    <WSForm.Field
      name={props.definition.key}
      component={WSInputNumber}
      componentProps={{
        label: props.definition.name,
        helperText: props.definition.description,
        required: props.definition.isRequired,
        min: props.definition.validationRules?.minimum,
        max: props.definition.validationRules?.maximum,
        maxFractionDigits: 2,
        disabled: props.disabled
      }}
    />
  );
};
